import { CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStopShowasQuickInfo extends Layout {
	citystateShowAs: CityState;
	panelShowas: Panel;
	sourceStop: DataSource;
	textboxAddress1: Textbox;
	textboxAddress2: Textbox;
	textboxLocationId: Textbox;
	textboxLocationName: Textbox;
}
